// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"b4ee0ea7","39":"8bc013c2","247":"b30df168","287":"0941ef6b","491":"b39fe63e","510":"d92660eb","555":"d25f1335","589":"0239c3ef","601":"ac918728","611":"d80d3771","675":"7c89efab","685":"c78acb89","747":"a92450b4","944":"97f1de5d"}[chunkId] + ".chunk.js";
};